import React from "react"
import './style.scss'

const Spinner2 = () =>{
    return(<div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>)
}
export default Spinner2